import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import classnames from 'classnames'

function BlogPostTemplate(props) {
  const post = props.data.markdownRemark
  const siteTitle = get(props, 'data.site.siteMetadata.title')

  return (
    <article className={classnames('cf ph3 ph4-ns pv4 mw8-ns')}>
      <Helmet title={`${post.frontmatter.title} | ${siteTitle}`} />
      <header className="fn fl-ns w-40-ns pr4-ns">
        <div style={{ backgroundColor: '#28405A', color: '#E8E8E8' }} className="ph3 pv2">
          <h1 className="mb3 mt0 lh-title" style={{ color: '#E8E8E8' }}>{post.frontmatter.title}</h1>
          <time className="t6 ttu tracked">{post.frontmatter.date}</time>
        </div>
      </header>
      {/* eslint-disable react/no-danger */}
      <div className="fn fl-ns w-60-ns" dangerouslySetInnerHTML={{ __html: post.html }} />
      {/* eslint-enable react/no-danger */}
      <div className="cl" />
    </article>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/BlogPost.jsx